export const selectEquipmentDocumentStatus = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-equipment-document-status.html'),
    controller: 'SelectEquipmentDocumentStatusController'
};
